// extracted by mini-css-extract-plugin
module.exports = {"menu":"share-dropdown_menu__ec6Zv","trigger":"share-dropdown_trigger___EB5W","trigger--selected":"share-dropdown_trigger--selected__OqhHn"};